import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { ListContext } from './parts/list-context.js';

var List = function List(_ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'ul' : _ref$tag,
      _ref$itemTag = _ref.itemTag,
      itemTag = _ref$itemTag === void 0 ? 'li' : _ref$itemTag,
      _ref$iconPlacement = _ref.iconPlacement,
      iconPlacement = _ref$iconPlacement === void 0 ? 'left' : _ref$iconPlacement,
      disabled = _ref.disabled,
      size = _ref.size,
      mode = _ref.mode,
      theme = _ref.theme,
      onItemClick = _ref.onItemClick,
      restProps = _objectWithoutProperties(_ref, ["tag", "itemTag", "iconPlacement", "disabled", "size", "mode", "theme", "onItemClick"]);

  return React.createElement(ListContext, {
    itemTag: itemTag,
    iconPlacement: iconPlacement,
    disabled: disabled,
    size: size,
    mode: mode,
    theme: theme,
    onItemClick: onItemClick
  }, React.createElement(Tag, restProps));
};
List.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  mode: PropTypes.oneOf(['nude', 'cell']),
  theme: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  itemTag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  onItemClick: PropTypes.func
};

export { List };
